import { PmsColor } from '@midocean/webapps-shared-domain';
import { SpotColor } from '@/components/w2pFileUploader/typings/Artwork';
import {
  AnnotationShape,
  LogoShape,
} from '@/web-components/import-wizard/typings/pintura';
import { ValidationResult, ValidatorResult } from '../index';

export const spotColorsValidator =
  (shape: LogoShape, printPositionId: string) =>
  ({ payload, validationResult }: ValidatorResult): ValidatorResult => {
    const validatorName = 'spotColorsValidator';

    const { pmsColorsInPngFile } = shape;

    const nonOriginalSpotColorsDetected = pmsColorsInPngFile?.filter(
      (p) => p.isOriginalSpotColor === false
    ) as PmsColor[];
    const resultColor: string =
      nonOriginalSpotColorsDetected.length > 0 ? 'Red' : 'Green';

    payload.id = shape.id;
    payload.personalizationArtworkId = shape.personalizationArtworkId as string;
    payload.fileName = shape.fileName as string;
    payload.spotColorsInOriginalFile =
      shape.spotColorsInOriginalFile as SpotColor[];

    return {
      payload,
      validationResult: validationResult.concat([
        {
          printPositionId: printPositionId,
          validatorName: validatorName,
          validatorColor: resultColor,
        },
      ]) as ValidationResult,
    };
  };
